import { FrigadeForm } from "@frigade/react";
import { defaultAppHost } from "../../api/api";
import { developmentOnboardingFlowId, productionOnboardingFlowId } from "../../settings/frigade";
import "./style/FrigadeOnBoarding.module.scss";

export default function FrigadeOnBoarding() {
  const isProduction = window.location.hostname === defaultAppHost;
  const flowId = isProduction ? productionOnboardingFlowId : developmentOnboardingFlowId;

  return (
    <FrigadeForm
      flowId={flowId}
      type="modal"
      endFlowOnDismiss={true}
      dismissible={true}
      showFrigadeBranding={false}
      className={"globalClass"}
    />
  );
}
